module.exports = __webpack_public_path__ + "static/media/iconExercises.21182fa3.svg";